export const STEPS_ID = {
	LOGIN: 0,
	INFO: 1,
	DOCUMENTS: 2,
	PAYMENT: 3,
	FINISH: 4,
	RESET: 5,
	COMPANY: 6,
	PAYER: 7,
};

export const STEPS = {
	LOGIN: 'login',
	LOGIN_ID: 'loginId',
	INFO: 'info',
	DOCUMENTS: 'documents',
	PAYMENT: 'payment',
	FINISH: 'finish',
	COMPANY: 'company',
	RESET: 'reset',
	PAYER: 'payer',
};

export const STEPS_COMPONENT = {
	login: 'AuthStep',
	loginId: 'AuthStepWithId',
	info: 'FirstStep',
	documents: 'SecondStep',
	payment: 'ThirdStep',
	finish: 'SuccessStep',
	company: 'CompanyStep',
	payer: 'PayerStep',
};

export const STEPS_LIST = [
	{
		id: STEPS_ID.LOGIN, name: STEPS.LOGIN, title: 'Логин / регистрация', completed: true,
	},
	{
		id: STEPS_ID.PAYER, name: STEPS.PAYER, title: 'Тип плательщика', completed: true,
	},
	{
		id: STEPS_ID.INFO, name: STEPS.INFO, title: 'Основная информация', completed: true,
	},
	{
		id: STEPS_ID.DOCUMENTS, name: STEPS.DOCUMENTS, title: 'Документы', completed: false,
	},
];

export const FINISH_STEP = 'finish';
